import $ from "jquery";
import {$doc, $win} from "./_globals.js";
import {drag} from "./utils";

function clamp(x, min, max) {
  return Math.min(max, Math.max(min, x));
}

function getOffset(el) {
  var left = 0;
  var top = 0;
  var i = el;
  while(!$(i).hasClass("modal")) {
    left += i.offsetLeft;
    top += i.offsetTop;
    i = i.parentNode;
  }

  return {
    left: left,
    top: top,
    width: el.offsetWidth,
    height: el.offsetHeight
  };
}

$doc.on("shown.bs.modal", ".modal-draggable", function($evt) {
  var $modal = $($evt.target);
  var $content = $($modal.find(".modal-content"));
  var $handle = $($modal.find(".modal-draggable-handle"));

  if(!$handle.length) return;

  var handle = $handle.get(0);
  var content = $content.get(0);
  var modal = $modal.get(0);

  $content.css({ transition: "none" });

  var startX = 0, startY = 0, x, y;
  var inited = false;

  function setXY(x_, y_) {
    var handleOffset = getOffset(handle);
    var minX = -handleOffset.left;
    var maxX = minX + modal.offsetWidth - handleOffset.width;
    var minY = -handleOffset.top;
    var maxY = minY + modal.offsetHeight - handleOffset.height;
    x = clamp(x_, minX, maxX);
    y = clamp(y_, minY, maxY);
    $content.css({ transform: "translate("+x+"px,"+y+"px)" });
  }

  var grabbing = false;

  var dragHandle = drag({
    el: $handle.get(0),
    onStart: function(coords, evt) {
      if($(evt.target).closest(":button").length) return;
      grabbing = true;

      $modal.addClass("modal-grabbing");
      if(!inited) {
        var offset0 = getOffset(content);
        $modal.addClass("modal-dragging");
        var offset1 = getOffset(content);
        x = startX = offset0.left - offset1.left;
        y = startY = offset0.top - offset1.top;
        $content.css({ transform: "translate("+startX+"px,"+startY+"px)" });
        inited = true;
      }
    },
    onMove: function(coords) {
      if (!grabbing) return;
      setXY(x = startX + coords.deltaX, y = startY + coords.deltaY);
    },
    onEnd: function() {
      if(!grabbing) return;

      var rect = content.getBoundingClientRect();
      if(rect.left === 0 && rect.top === 0) {
        startX = 0;
        startY = 0;
        $content.css({ transform: "" });
        inited = false;
      } else {
        startX = x;
        startY = y;
      }
      $modal.removeClass("modal-grabbing");

      grabbing = false;
    }
  });

  function onResize() {
    if(inited) {
      setXY(startX, startY);
      startX = x;
      startY = y;
    }
  }

  $win.on("resize", onResize);

  $modal.one("hidden.bs.modal", function() {
    dragHandle.unbind();
    $content.css({
      transform: "",
      transition: ""
    });
    $modal.removeClass("modal-dragging");
    $win.off("resize", onResize);
  });
});
